export const MenuItemCheckSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="10" height="10">
  <style>
    .disabled{opacity:0.35}
    .active path{fill:#333}
    path,.disabled path{fill:#666}
  </style>
  <path d="M4.2 9.3C4 9.3 3.8 9.2 3.7 9.1l-3-3L1.8 5l2.3 2.3 4-6.7 1.3 0.8L4.9 9C4.7 9.2 4.5 9.3 4.2 9.3L4.2 9.3z" />
</svg>`;
